module.exports = __webpack_public_path__ + "static/media/meetimg2.b2615b0b.jpg";